import { createReducer, on } from '@ngrx/store';
import { AppSettingsApiActions } from '../app-settings/app-settings.actions';
import { ApplicationsConfiguredSettingsApiActions } from './applications-configured-settings.actions';
import { adapter, initialState } from './applications-configured-settings.state';

export const applicationsConfiguredSettingsReducer = createReducer(
  initialState,
  on(ApplicationsConfiguredSettingsApiActions.applicationsConfiguredSettingsLoaded, (state, { settings }) =>
    adapter.upsertMany(settings, state)
  ),
  on(AppSettingsApiActions.appSettingsUnlinkedFromCategory, (state, { settingId }) =>
    adapter.removeOne(settingId, state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectApplicationsConfiguredSettingsIds = selectIds;

export const selectApplicationsConfiguredSettingsEntities = selectEntities;

export const selectAllApplicationsConfiguredSettings = selectAll;
